import React, {Component} from 'react';
import {Label} from 'semantic-ui-react';
import connect from "react-redux/es/connect/connect";
import {comboDialog} from "../../actions/ComboDialogActions";
import {productVariantsDialog} from "../../actions/ProductVariantsDialogActions";

class ProductType extends Component {
    render() {
        return this.props.product_type === 'U' ? <Label>Unico</Label> : this.props.product_type === 'V' ?
            <Label as='a' color='orange' onClick={()=>this.props.productVariantsDialog({is_open:true, product: this.props, id: this.props.id, loading:true})}>Variante</Label> :
            <Label as='a' color='orange' onClick={()=>this.props.comboDialog({is_open:true, name: this.props.name, id: this.props.id, loading:true})}>Combo</Label>;
    }
}

function mapDispatchToProps(dispatch){
    return {
        comboDialog(data){
            dispatch(comboDialog(data))
        },
        productVariantsDialog(data){
            dispatch(productVariantsDialog(data))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(ProductType)


// WEBPACK FOOTER //
// ./src/components/inventories/ProductType.js